<template>
    <div>
        <div class="backdrop" v-if="open" @click="toggle"></div>
        <div class="dropdown" :class="{ 'is-active': open }">
            <div class="dropdown-trigger">
                <button
                    class="button dropdown-button"
                    aria-haspopup="true"
                    aria-controls="dropdown-menu"
                    @click="toggle"
                >
                    <span v-if="selected !== null">{{ selected.displayName }}</span>
                    <span
                        v-if="selected === null"
                        :class="{ 'greyscale-placeholder': greyscalePlaceholder }"
                    >
                        {{ placeholder }}
                    </span>
                    <span class="icon is-small">
                        <i v-if="!open" class="fas fa-angle-down" aria-hidden="true"></i>
                        <i v-if="open" class="fas fa-angle-up" aria-hidden="true"></i>
                    </span>
                </button>
            </div>
            <div class="dropdown-menu" id="dropdown-menu" role="menu">
                <div class="dropdown-content">
                    <a
                        v-for="option in options"
                        :key="option.value"
                        class="dropdown-item"
                        :class="{
                            'is-active': selected !== null && selected.value === option.value,
                        }"
                        @click="select(option)"
                    >
                        {{ option.displayName }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'DropDown',
    props: {
        options: Array, // {value, displayName}
        selected: Object,
        placeholder: String,
        greyscalePlaceholder: Boolean,
        onUpdate: Function,
    },
    data: () => ({
        open: false,
    }),
    methods: {
        toggle() {
            this.open = !this.open
        },
        select(value) {
            this.open = false
            this.onUpdate(value)
        },
    },
}
</script>

<style lang="scss" scoped>
@import '../sass/variables';
.backdrop {
    position: fixed;
    z-index: 10;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}
.greyscale-placeholder {
    color: grey;
}

.dropdown {
    width: 100%;
}

.dropdown-item {
    white-space: initial;
}

.dropdown-trigger {
    width: 100%;
}

.dropdown-menu {
    width: 100%;
    z-index: 30;
}

.dropdown-button {
    width: 100%;
    display: flex;
    justify-content: space-between;
}

.dropdown-button span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>
